// extracted by mini-css-extract-plugin
module.exports = {"root":"Footer_root__3dXK0","buttons":"Footer_buttons__1Rsrx"};